import { createDCHook, collapseDataFromCall } from '../client';
import { getDynamicPrices } from '../services/UsageDynamicPriceService';

export const useUsageDynamicPriceGetDynamicPrices = createDCHook(
  'getDynamicPrices',
  collapseDataFromCall(getDynamicPrices),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);
